import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';

import getOrganizationByStatus from '../../graphql/SuperAdmin';
import { requestUserByEmail, getGovernmentUsers, allProcurementUser } from '../../graphql/users';
import history from '../../config/history';
import { requestOrganizationById, organizationByCage } from './graphql';
// import history from '../../config/history';
import { superAdminHomeRoute } from '../../config/navigation/routes';

export default function SuperAdminHOC(SuperAdminMenu) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    };

    static initialState = {
      showToast: false,
      toastLevel: '',
      toastMessage: '',
      // govOrgId: 'test',
      requests: [],
      errors: [],
      isLoading: true,
      selectedMenu: { text: 'View Pending Request', value: 'pendingReqs' },
      cage: null,
      email: null,
      users: [],
      loading: false,
      organizationsCage: undefined,
      organizationStatus: undefined,
      organizationsName: undefined,
      userType: {
        isAllUsers: true,
        isGovernmentUser: false
      },
      govUsers: [],
      industryUsersList: []
    };

    state = WrappedComponent.initialState;
    async fetchAllProcUsers() {
      try {
        const response = await allProcurementUser();
        this.setState({
          isLoading: false,
          users: response.allProcurementUser.govProcUserData,
        });
      } catch (error) {
        message.error('Failed to load Proc users');
        this.setState({ isLoading: false });
      }
    }

    async componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        await this.fetchAllProcUsers();
      }

    }
    static getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.email === '' && prevState.userType.isGovernmentUser) {
        return {
          users: prevState.govUsers
        };
      }
      if (prevState.email === '' && !prevState.userType.isGovernmentUser) {
        return {
          users: prevState.industryUsersList
        }
      }
      if (prevState.cage === '' && prevState.userType.isGovernmentUser) {
        return {
          users: prevState.govUsers
        };
      }
      if (prevState.cage === '' && !prevState.userType.isGovernmentUser) {
        return {
          users: prevState.industryUsersList
        };
      }
      return null;
    }
    async componentDidMount() {
      if (!this.users) {
        await this.fetchAllProcUsers();
      }
      // const res = await organizationByCage('O0000');
      // const govOrgId = res.organizationInDB.id;
      // this.setState({
      //   govOrgId,
      // });
      const {
        location: { pathname },
      } = this.props;
      const page = pathname.match(/([^\/]*)\/*$/)[1];
      let response;
      if (page === ':page' || page === 'home') {
        const url = superAdminHomeRoute.replace(':page', 'pendingReqs');
        history.replace(url);
        response = await getOrganizationByStatus('requested');
        if (response.organizationByStatus) {
          requests = response.organizationByStatus.organizations || [];
        } else {
          requests = [];
        }
        this.setState({
          requests,
          isLoading: false,
        });
      } else {
        // the list of filters for the tab name for refresh and hot linking if you add a new page you need to add it to this filter list
        const filters = {
          searchUsers: { text: 'Search Users', value: 'searchUsers' },
          addOrganization: {
            text: 'Add New Organization',
            value: 'addOrganization',
          },
          viewEntities: { text: 'View Organizations', value: 'viewEntities' },
          pendingReqs: { text: 'View Pending Request', value: 'pendingReqs' },
          rejectedReqs: {
            text: 'View Rejected Request',
            value: 'rejectedReqs',
          },
          banner: {
            text: 'Edit Banner',
            value: 'banner',
          },
        };

        this.setState({ selectedMenu: filters[page] });
        switch (page) {
          case 'pendingReqs':
            response = await getOrganizationByStatus('requested');
            if (response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;

          case 'viewEntities':
            response = await getOrganizationByStatus('approved');
            if (response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;
          case 'rejectedReqs':
            response = await getOrganizationByStatus('denied');
            if (response.organizationByStatus) {
              requests = response.organizationByStatus.organizations || [];
            } else {
              requests = [];
            }
            this.setState({
              requests,
              isLoading: false,
            });
            break;
          default:
            this.setState({
              isLoading: false,
            });
            break;
        }
      }
      let requests;
      if (response) {
        if (response.organizationByStatus) {
          requests = response.organizationByStatus.organizations || [];
        } else {
          requests = [];
        }

        this.setState({
          requests,
          isLoading: false,
        });
      }
    }

    // componentWillReceiveProps(nextProps) {
    //   const pathname = nextProps.location.pathname;
    //   const page = pathname.match(/([^\/]*)\/*$/)[1];
    //   if (page === ':page' || page === 'home') {
    //     const url = superAdminHomeRoute.replace(':page', 'pendingReqs');
    //     history.replace(url);
    //   }
    // }

    _onNewUserClick = () => {
      const { users } = this.state;
      const newUser = {
        fullName: '',
      };
      const updatedUsers = [...users, newUser];
      this.setState({ users: updatedUsers, viewNewUserForm: true });
    };

    _onSubmit = async (cage, email, currentUserType) => {
      // const { email } = this.state;

      this.setState({
        // users: response.organization.users,
        isLoading: true,
      });
      if (email === '' && currentUserType) {
        this.setState({
          users: this.state.govUsers
        })
      }
      else {
        this.setState({
          users: this.industryUsersList
        })
      }
      if (cage === '' && currentUserType) {
        this.setState({
          users: this.state.govUsers
        })
      }
      else {
        this.setState({
          users: this.industryUsersList
        })
      }
      if (email !== '') {
        if (currentUserType) {
          const govUsers = this.state.govUsers;
          const currentUser = govUsers.find((el) => el.email === email);
          if (currentUser) {
            const org = await requestOrganizationById(
              currentUser.organizationId,
            )
            if (org) {
              this.setState({
                isLoading: false,
                users: currentUser ? [currentUser] : [],
                organizationsCage: org.organization.cageCode,
                organizationsName: org.organization.name,
                organizationsStatus: org.organization.iconStatus,
              });
            }
            return
          }
          this.setState({
            isLoading: false,
            users: [],
          });
          return
        }
        const industryUsers = this.state.industryUsersList.find((el) => el.email === email);
        if (!industryUsers) {
          this.setState({
            isLoading: false,
            users: [],
          });
          return
        }
        const response = await requestUserByEmail(email);

        if (response.userByEmail) {
          const org = await requestOrganizationById(
            response.userByEmail.organizationId,
          );

          this.setState({
            isLoading: true,
            users: [response.userByEmail],
            organizationsCage: org.organization.cageCode,
            organizationsName: org.organization.name,
            organizationsStatus: org.organization.iconStatus,
          });
        } else {
          this.setState({
            isLoading: false,
            users: [],
            organizationsCage: undefined,
            organizationsName: undefined,
            organizationsStatus: undefined,
          });


          message.error('No User Found ');
        }
      } else if (cage !== '') {
        const response = await organizationByCage(
          cage.toUpperCase(),
        );

        if (currentUserType && response.organizationInDB) {
          const govUsers = this.state.govUsers;
          const currentUser = govUsers.filter((el) => el.cageCode.trim() === cage);
          this.setState({
            isLoading: false,
            users: currentUser,
            organizationsCage: response.organizationInDB.cageCode,
            organizationsName: response.organizationInDB.name,
            organizationsStatus: response.organizationInDB.iconStatus,
          });
          return
        }

        if (response.organizationInDB) {
          this.setState({
            isLoading: true,
            users: response.organizationInDB.users.filter((el) => el.role !== 'government_user'),
            organizationsCage: response.organizationInDB.cageCode,
            organizationsName: response.organizationInDB.name,
            organizationsStatus: response.organizationInDB.iconStatus,
          });
        } else {
          this.setState({
            isLoading: false,
            users: [],
            organizationsCage: undefined,
            organizationsName: undefined,
            organizationsStatus: undefined,
          });
        }

      }
      this.setState({
        // users: response.organization.users,
        isLoading: false,
      });

    };

    fetchAllProcUsers = async () => {
      try {
        this.setState({
          isLoading: true,
          userType: {
            isGovernmentUser: false,
            isAllUsers: true
          }
        });
        const response = await allProcurementUser();
        const filterResponse = response.allProcurementUser.govProcUserData.filter(el => (el.name !== '')).filter((el) => el.role !== 'government_user')
        this.setState({
          isLoading: false,
          users: filterResponse,
          industryUsersList: filterResponse
        });
      } catch (error) {
        this.setState({ isLoading: false });
      }
    }
    _onGetGovernmentUsers = async () => {

      this.setState({
        email: undefined,
        cage: undefined,
        isLoading: true,
      });

      const response = await getGovernmentUsers();

      this.setState({
        users: response.governmentUsers.govProcUserData,
        organizationsCage: undefined,
        organizationsName: undefined,
        organizationsStatus: undefined,
        govUsers: response.governmentUsers.govProcUserData
      });

      this.setState({
        isLoading: false,
      });

    };

    _onChange = e => {
      const value = e.target.value;
      const name = e.target.name;
      if (name === 'email') {
        this.setState({
          email: value,
          cage: undefined
        });
      } else if (name === 'cage') {
        this.setState({
          cage: value,
          email: undefined
        });
      } else if (name === 'orgName') {
        this.setState({
          orgName: value,
          orgCage: undefined
        });
      } else if (name === 'orgCage') {
        this.setState({
          orgCage: value,
          orgName: undefined
        });
      }


    };

    _refreshUsers = async () => {

      this.setState({
        // users: response.organization.users,
        isLoading: true,
      });
      // set timeout so changes have chance to get via dynamoDB to DB2 before reloading the users

      if (this.state.email) {
        const response = await requestUserByEmail(this.state.email);
        this.setState({
          users: [response.userByEmail],
          isLoading: false,
        });
      } else if (this.state.cage) {
        const response = await organizationByCage(
          this.state.cage.toUpperCase(),
        );
        this.setState({
          isLoading: false,
          users: response.organizationInDB.users,
        });
      } else {
        setTimeout(async () => {
          if (this.state.userType.isGovernmentUser) {

            const response = await getGovernmentUsers();
            this.setState({
              isLoading: false,
              users: response.governmentUsers.govProcUserData,
              govUsers: response.governmentUsers.govProcUserData
            });
          }
          if (this.state.userType.isAllUsers) {

            const response = await allProcurementUser();
            const filterResponse = response.allProcurementUser.govProcUserData.filter(el => (el.name !== '')).filter((el) => el.role !== 'government_user')
            this.setState({
              isLoading: false,
              users: filterResponse,
              industryUsersList: filterResponse
            });
          }
        }, 1500)
      }

    };

    _onHandleUserTypeSwitchChange = (switchType, checked) => {
      this.setState({
        userType: {
          isAllUsers: switchType === "allUsers" ? checked : !checked,
          isGovernmentUser: switchType === "governmentUsers" ? checked : !checked
        }
      },
        () => {
          if (this.state.userType.isAllUsers) {
            this.setState({
              isLoading: true,
            });
            this.fetchAllProcUsers()
          }

          if (this.state.userType.isGovernmentUser) {
            this._onGetGovernmentUsers()
          }
        }
      );
    };

    _onViewOrgSubmit = async (orgName, cageCode) => {
      this.setState({
        requests: [],
        isLoading: true,
      });

      const orgsArray = [];
      const response = await getOrganizationByStatus('approved');
      let requests = response.organizationByStatus.organizations || [];

      if (response.organizationByStatus && cageCode !== '') {
        let cage = '';
        for (let i = 0; i < requests.length; i++) {
          cage = requests[i].cageCode;
          if (cage !== null) {
            cage = cage.toString().toUpperCase();
            if (cage.indexOf(cageCode.toUpperCase()) !== -1) {
              orgsArray.push(requests[i]);
            }
          }
        }
        requests = orgsArray;
        if (orgsArray.length === 0) {
          requests = [];
        }
      } else if (response.organizationByStatus && orgName !== '') {
        let name = '';
        for (let i = 0; i < requests.length; i++) {
          name = requests[i].name;
          if (name !== null) {
            name = name.toString().toLowerCase();
            if (name.indexOf(orgName.toLowerCase()) !== -1) {
              orgsArray.push(requests[i]);
            }
          }
        }
        requests = orgsArray;
        if (orgsArray.length === 0) {
          requests = [];
        }
      } else {
        requests = [];
      }
      this.setState({
        requests,
        isLoading: false,
      });

      //  const url = superAdminHomeRoute.replace(':page', 'viewEntities');
      // history.replace(url);
    };

    _onFilterClick = async filter => {
      this.setState({
        selectedMenu: filter,
        requests: [],
        isLoading: true,
      });
      this.refreshOrganizations(filter);
      const url = superAdminHomeRoute.replace(':page', filter.value);
      history.replace(url);
    };

    refreshOrganizations = async (filter = this.state.selectedMenu) => {
      let response;
      let requests;
      switch (filter.value) {
        case 'pendingReqs':
          response = await getOrganizationByStatus('requested');
          if (response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });
          break;

        case 'viewEntities':
          response = await getOrganizationByStatus('approved');
          if (response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });

          break;

        case 'rejectedReqs':
          response = await getOrganizationByStatus('denied');
          if (response.organizationByStatus) {
            requests = response.organizationByStatus.organizations || [];
          } else {
            requests = [];
          }
          this.setState({
            requests,
            isLoading: false,
          });
          break;
        default:
          this.setState({
            isLoading: false,
          });
          break;
      }
    }

    _onError = (toastLevel, toastMessage) => {
      this.setState(
        {
          toastLevel,
          toastMessage,
          showToast: true,
        },
        () => {
          setTimeout(() => this.setState({ showToast: false }), 3000);
        },
      );
    };

    render() {
      const {
        isLoading,
        requests,
        selectedMenu,
        users,
        loading,
        toastLevel,
        toastMessage,
        showToast,
        organizationsCage,
        organizationsName,
        organizationsStatus,
        // govOrgId,
        email,
        cage,
        orgName,
        orgCage,
      } = this.state;
      const { auth } = this.props;
      const pageProps = {
        // govOrgId,
        organizationsCage,
        organizationsName,
        organizationsStatus,
        refreshUsers: this._refreshUsers,
        loading,
        toastLevel,
        toastMessage,
        showToast,
        onSubmit: this._onSubmit,
        onGetGovernmentUsers: this._onGetGovernmentUsers,
        onChange: this._onChange,
        onViewOrgSubmit: this._onViewOrgSubmit,
        users,
        auth,
        requests,
        isLoading,
        selectedMenu,
        onMenuClick: this._onFilterClick,
        viewNewUserForm: this.state.viewNewUserForm,
        email,
        cage,
        orgName,
        orgCage,
        refreshOrganizations: this.refreshOrganizations,
        onHandleUserTypeSwitchChange: this._onHandleUserTypeSwitchChange,
        userType: this.state.userType,
      };
      return <SuperAdminMenu {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/SuperAdminHomeHOC.jsx